import React from "react";
import { Box, Button, makeStyles, Typography } from "@material-ui/core";
import Input from "components/input/inputTextField";
//import FilterSvg from "assets/svg/filter.svg";
import { Formik } from "formik";
import clsx from "clsx";
import DateRangePicker from "components/input/dateRangePicker";
import BranchSearch from "modules/stockflow/components/select/branchSearch";
import RecallListTable from "modules/stockflow/components/table/recallListTable";
import RecallRequestorSearch from "modules/stockflow/components/select/recallRequestorSearch";
import RecallDealerSearch from "modules/stockflow/components/select/recallDealerSearch";
import { getLang } from "app/feature/constants";
import ExportExcelSelect from "modules/warrantee/components/select/exportExcelSelect";

const useStyle = makeStyles((theme) => ({
  searchContainer: {
    backgroundColor: theme.palette.background.paper,
    display: "grid",
    gridTemplateColumns: "4fr 3fr 1fr 1.6fr",
    columnGap: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      gridTemplateColumns: "1fr",
      gridRowGap: theme.spacing(1),
      rowGap: theme.spacing(1),
    },
  },
  exportButton: {
    backgroundColor: "#ffffff",
    height: 43,
    borderRadius: 4,
    padding: "5px 12px",
    borderColor: "#D0D5DD",
  },
  inputRootID: {
    paddingTop: "8px !important",
    paddingBottom: "7px !important",
    paddingLeft: "12px !important",
    paddingRight: "12px !important",
    fontSize: "0.875rem",
    fontWeight: 550,
  },
  filterMainContainer: {
    backgroundColor: theme.palette.background.paper,
    padding: "0px 16px 4px",
    marginBottom: "12px",
  },
  filterFieldContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    columnGap: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      gridTemplateColumns: "1fr",
      gridRowGap: theme.spacing(1),
      rowGap: theme.spacing(1),
    },
  },
  paperRoot: {
    width: "217px",
  },
  emptyField: {
    "& .MuiInputBase-root": {
      color: "#A4A6A8",
    },
  },
}));

export default function RecallListingComponent({
  hasStockflowRecallViewAccessRight,
  hasStockflowDealerViewAccessRight,
  isFetching,
  selectedIds,
  isSelectAll,
  language,
  selectedCount,
  isError,
  handleChangePage,
  handleChangeRowsPerPage,
  totalFiltered,
  page,
  rowsPerPage,
  handleSearch,
  clearSearch,
  handleReload,
  isSearchResult,
  handleSelectRecall,
  handleSelectAvailable,
  handleSelectAll,
  handleDeselectAll,
  paginationOptions,
  isExporting,
  isFilterOpen,
  setIsFilterOpen,
  tableFilter,
  changeOrder,
  lang,
  resetFilter,
  handleViewDetail,
  recalls,
  handleExport,
}) {
  const classes = useStyle();
  const exportDropdown = [
    { name: "CSV", value: "csv" },
    { name: "Excel", value: "xlsx" },
  ];
  return (
    <>
      <Formik
        initialValues={{
          search: tableFilter.search,
          dateRange: {
            from: tableFilter.fromDate,
            to: tableFilter.toDate,
          },
          branch: tableFilter.branch,
          recallBy: tableFilter.recallBy,
          recallFrom: tableFilter.recallFrom,
        }}
        enableReinitialize
        onSubmit={(values, actions) => {
          handleSearch(values);
          actions.setSubmitting(false);
        }}
      >
        {(formik) => (
          <form onSubmit={formik.handleSubmit}>
            <Box p={2} my={0} className={classes.searchContainer}>
              <Input
                hiddenLabel
                variant="filled"
                size="small"
                placeholder={getLang(lang, "placeholder.SEARCH_RECALL_ID")}
                margin="none"
                InputProps={{
                  disableUnderline: true,
                  margin: "none",
                  style: {
                    borderRadius: "4px",
                    backgroundColor: "#eceff0",
                    minWidth: "50px",
                    height: "100%",
                  },
                  classes: { input: classes.inputRootID },
                }}
                {...formik.getFieldProps("search")}
              />
              <DateRangePicker
                label=""
                placeholder={getLang(lang, "placeholder.RECALL_DATE")}
                disabled={isFetching}
                disableFuture={false}
                className={clsx({
                  [classes.emptyField]:
                    !formik.getFieldProps("dateRange").value,
                })}
                id={"created-picker-dialog"}
                value={formik.getFieldProps("dateRange").value}
                handleChange={(v) => {
                  formik.setFieldValue("dateRange", v);
                }}
                InputPropStyle={{
                  color: !formik.getFieldProps("dateRange").value
                    ? "#A4A6A8"
                    : "#000000",
                  fontWeight: "normal",
                }}
                inputProps={{
                  fontWeight: "400",
                  fontSize: "16px",
                }}
                title={getLang(lang, "placeholder.RECALL_DATE")}
              />
              <Button
                variant="text"
                disableElevation
                color="secondary"
                size="small"
                disabled={isFetching}
                onClick={() => {
                  formik.resetForm();
                  clearSearch();
                }}
              >
                {getLang(lang, "label.CLEAR")}
              </Button>
              <Button
                disabled={isFetching}
                variant="contained"
                disableElevation
                color="primary"
                size="small"
                type="submit"
              >
                {getLang(lang, "label.SEARCH")}
              </Button>
            </Box>
            <Box className={classes.filterMainContainer}>
              <Box
                className={classes.filterFieldContainer}
                style={{ marginBottom: "12px" }}
              >
                <BranchSearch
                  placeholder={getLang(lang, "placeholder.BRANCH")}
                  value={formik.values.branch}
                  handleChange={(value) =>
                    formik.setFieldValue("branch", value)
                  }
                  isEmpty={formik.values.branch?.length === 0}
                  styles={{
                    padding: "0.5em 1em",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderRadius: 4,
                    width: "100%",
                    overflow: "hidden",
                    height: 36,
                  }}
                  handleChipDelete={(branch) => {
                    let temp = [...formik.values.branch];
                    if (temp.length > 0) {
                      const filteredBranchs = temp.filter(
                        (item) => item.node_id !== branch.node_id
                      );
                      temp = [...filteredBranchs];
                    }
                    formik.setFieldValue("branch", temp);
                  }}
                />
                <RecallRequestorSearch
                  placeholder={getLang(lang, "placeholder.RECALL_BY")}
                  value={formik.values.recallBy}
                  handleChange={(value) => {
                    formik.setFieldValue("recallBy", value);
                  }}
                  isEmpty={formik.values.recallBy?.length === 0}
                  styles={{
                    padding: "0.5em 1em",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderRadius: 4,
                    width: "100%",
                    overflow: "hidden",
                    height: 36,
                  }}
                  handleChipDelete={(requestor) => {
                    let temp = [...formik.values.recallBy];
                    if (temp.length > 0) {
                      const filteredRecallRequestor = temp.filter(
                        (item) => item !== requestor
                      );
                      temp = [...filteredRecallRequestor];
                    }
                    formik.setFieldValue("recallBy", temp);
                  }}
                />
                <RecallDealerSearch
                  placeholder={getLang(lang, "placeholder.DEALER")}
                  value={formik.values.recallFrom}
                  handleChange={(value) => {
                    formik.setFieldValue("recallFrom", value);
                  }}
                  isEmpty={formik.values.recallFrom?.length === 0}
                  styles={{
                    padding: "0.5em 1em",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderRadius: 4,
                    width: "100%",
                    overflow: "hidden",
                    height: 36,
                  }}
                  handleChipDelete={(requestor) => {
                    let temp = [...formik.values.recallFrom];
                    if (temp.length > 0) {
                      const filteredRecallDealer = temp.filter(
                        (item) => item !== requestor
                      );
                      temp = [...filteredRecallDealer];
                    }
                    formik.setFieldValue("recallFrom", temp);
                  }}
                />
              </Box>
              <Box
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              ></Box>
            </Box>
          </form>
        )}
      </Formik>

      <Box
        style={{
          display: "flex",
          justifyContent: "space-between",
          paddingBottom: "12px",
        }}
      >
        <Box style={{ display: "flex" }}>
          <Box style={{ display: "flex", alignItems: "center" }}>
            {selectedCount !== 0 ? (
              isSelectAll && selectedCount === totalFiltered ? (
                <Typography variant="body2" style={{ color: "#FDB022" }}>
                  {getLang(lang, "paragraph.SELECTED_ALL_RECORDS", {
                    count: selectedCount,
                  })}
                </Typography>
              ) : (
                <Typography variant="body2" color="primary">
                  {selectedCount > 1
                    ? getLang(lang, "paragraph.SELECTED_RECORDS_COUNT", {
                        count: selectedCount,
                      })
                    : getLang(lang, "paragraph.SELECTED_RECORD_COUNT", {
                        count: selectedCount,
                      })}
                </Typography>
              )
            ) : (
              ""
            )}
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            mb: 2,
          }}
        >
          <ExportExcelSelect
            disabled={isExporting || isFetching || recalls.length < 1}
            dropdownItem={exportDropdown}
            isLoading={isExporting}
            handleSelection={(type) => handleExport(type)}
          />
        </Box>
      </Box>
      <RecallListTable
        hasStockflowRecallViewAccessRight={hasStockflowRecallViewAccessRight}
        hasStockflowDealerViewAccessRight={hasStockflowDealerViewAccessRight}
        rows={recalls}
        isFetching={isFetching}
        selectedIds={selectedIds}
        isSelectAll={isSelectAll}
        isError={isError}
        handleReload={handleReload}
        page={page}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        language={language}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        isSearchResult={isSearchResult}
        totalFiltered={totalFiltered}
        handleSelectRecall={handleSelectRecall}
        handleSelectAvailable={handleSelectAvailable}
        handleSelectAll={handleSelectAll}
        handleDeselectAll={handleDeselectAll}
        paginationOptions={paginationOptions}
        tableFilter={tableFilter}
        changeOrder={changeOrder}
        lang={lang}
        handleViewDetail={handleViewDetail}
      />
    </>
  );
}
